<ng-template
    cdkConnectedOverlay
    mat-dialog-content
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="closeOverlay()">
    <mat-card [style.maxWidth]="'300px'">
        <mat-card-header [style.paddingBottom]="'16px'">
            <h2 class="heading-small">
                {{ 'shared.skeleton.languageSelection.header' | translate }}
            </h2>
        </mat-card-header>
        <mat-divider />
        <mat-card-content>
            <div class="mt-4 flex flex-row justify-center">
                <mat-chip-listbox
                    attr.aria-label=" {{
                        'shared.skeleton.languageSelection.chipListboxLabel'
                            | translate
                    }}">
                    @for (lang of languages(); track lang) {
                        <mat-chip-option
                            [attr.aria-label]="
                                'shared.languages.' + lang | translate
                            "
                            (click)="changeLanguage(lang)"
                            [selected]="isLangSelected(lang)"
                            [selectable]="!isLangSelected(lang)">
                            <!-- 'alt' of the image is intentionally blank -> The purpose of the flags is just presentation logic,.
                            For screen readers, there is an aria-label for each chip option -->
                            <img
                                src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                [class]="
                                    'flag flag-' +
                                    mapLangToCountry(lang).toLowerCase()
                                "
                                [alt]="mapLangToCountry(lang).toLowerCase()" />
                        </mat-chip-option>
                    }
                    @if (languages().length < 1) {
                        <p>
                            {{ 'shared.noDataRefresh' | translate }}
                        </p>
                    }
                </mat-chip-listbox>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
